<template>
  <form class="mx-auto col-sm-8" @submit.prevent>
    <div >
      <div
        class="form-group"
        :class="{ 'has-error': errors.has('send_date') }"
      >
        <label for="send_date">{{ $t("send_date") }}</label>
        <input
          type="date"
          id="send_date"
          name="send_date"
          class="form-control"
          :placeholder="$t('ph_send_date')"
          v-model="costMaterialTransportation.sendDate"
          v-validate="'required'"
        />
        <small v-show="errors.has('send_date')" class="form-text">
          {{ errors.first("send_date") }}
        </small>
      </div>

      <div class="form-group">
        <label for="send_method">{{ $t("send_method") }}</label>
        <Combobox
          class="bg-white"
          name="send_method"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('send_method')"
          :options="shippingMethodTransportation"
          label="name"
          :initial-value="costMaterialTransportation.sendMethod"
          v-model="costMaterialTransportation.sendMethod"
          :reduce="(sendMethod) => sendMethod.id"
          v-validate="'required'"
        />
      </div>

      <div class="form-group">
        <label for="send_destiny">{{ $t("send_destiny") }}</label>
        <Combobox
          class="bg-white"
          name="send_destiny"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('send_destiny')"
          :options="shippingDestinyTransportation"
          label="name"
          :initial-value="costMaterialTransportation.sendDestiny"
          v-model="costMaterialTransportation.sendDestiny"
          :reduce="(sendDestiny) => sendDestiny.id"
          v-validate="'required'"
        />
      </div>

      <div class="form-group">
        <label for="service">{{ $t("services") }}</label>
        <Combobox
          class="bg-white"
          name="service"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('service')"
          :options="serviceTypes"
          label="name"
          :initial-value="costMaterialTransportation.service"
          v-model="costMaterialTransportation.service"
          :reduce="(service) => service.id"
          v-validate="'required'"
        />
      </div>

      <div class="form-group">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('client')"
          :options="financialClients"
          label="nome_cliente"
          :initial-value="costMaterialTransportation.client"
          v-model="costMaterialTransportation.client"
          :reduce="(client) => client.id"
          v-validate="'required'"
        />
      </div>

      <div
        class="form-group"
        :class="{ 'has-error': errors.has('coast') }"
      >
        <label for="coast">{{ $t("coast") }}</label>
        <CurrencyInput
          :placeholder="$t('ph_coast')"
          v-model="costMaterialTransportation.coast"
          :auto-decimal-mode="true"
          :distraction-free="false"
          currency="BRL"
          locale="pt-BR"
          class="demo__currency-input form-control"
        />

        <small v-show="errors.has('coast')" class="form-text text-muted">
          {{ errors.first("coast") }}
        </small>
      </div>
    </div>

    <LoaderButton @click="onClick">
      {{ $t("save") }}
    </LoaderButton>
  </form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";

export default {
  name: "ActiveMovementForm",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      serials: [],
      movementTypesFiltered: [],
    };
  },

  props: {
    costMaterialTransportation: {
      type: Object,
      default: () => ({
        sendDate: '',
        sendMethod: null,
        sendDestiny: null,
        service: null,
        client: null,
        coast: 0
      }),
    },
  },

  computed: {
    ...mapState({
      serviceTypes: (state) => state.servicetypes.all,
      shippingMethodTransportation: (state) => state.shippingmethodtransportation.all,
      shippingDestinyTransportation: (state) => state.shippingdestinytransportation.all,
      financialClients: (state) => state.financial.clients,
    }),
  },

  methods: {
    ...mapActions("costmaterialtransportation", ["create", "edit"]),

    async onClick(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));
        this.$store.dispatch("notify/error", err);
        return;
      }

      const { id } = this.costMaterialTransportation;

      const result = (await id)
        ? await this.edit({ id, data: this.costMaterialTransportation })
        : await this.create(this.costMaterialTransportation);

      if (result) {
        this.$router.push({ name: "listcostmaterialtransportation" });
      }
    },
  },

  async mounted() {
    const { dispatch } = this.$store;

    dispatch('overlay/show', true)

    await Promise.all([
      dispatch("servicetypes/fetchAll"),
      dispatch("shippingmethodtransportation/fetchAll"),
      dispatch("shippingdestinytransportation/fetchAll"),
      dispatch("financial/fetchClients"),
    ])

    dispatch('overlay/show', false)
  },

  destroyed() {
    const { dispatch } = this.$store;

    dispatch("servicetypes/cleanState");
    dispatch("shippingmethodtransportation/cleanState");
    dispatch("shippingdestinytransportation/cleanState");
    dispatch("financial/cleanState");
  },
};
</script>
